import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PlusTag } from "../../../../components/PlusTag";
import { ScreenHeader } from "../../../../components/SubHeader";
import ChevronRightIcon from "../../../../icons/ChevronRight";
import CreationProgress from "../../components/CreationProgress";
import { Option, Options } from "./styles";

/** The ways to start, the AI first (the one we suggest): its emoji, its texts' key and where it goes. */
const WAYS = [
  { key: "ai", emoji: "✨", to: "/editor/ai", main: true },
  { key: "template", emoji: "🧩", to: "/editor/templates" },
  // from scratch too: its pages first, to add some if wanted (the home is one of them)
  { key: "scratch", emoji: "✏️", to: "/editor/pages" },
];

/**
 * Right after naming a new Keepo (its draft already exists): have the AI build it from the business's Instagram and
 * the owner's words, start from a ready-made template for its field of work, or start it empty, section by section.
 */
const StartPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const prefix = "pages.editor.start";

  return (
    <div>
      {/* where the person is in the flow, on top; the screen's own header under it */}
      <CreationProgress step="start" />
      <ScreenHeader title={t(`${prefix}.title`)} back={{ label: t(`${prefix}.back`), to: "/editor/title" }} />
      {/* One card per way, as the lists on /domains; the AI's in the brand's green */}
      <Options>
        {WAYS.map(({ key, emoji, to, main }) => (
          <li key={key}>
            <Option type="button" $main={main} onClick={() => navigate(to)}>
              <span className="emoji" aria-hidden="true">
                {emoji}
              </span>
              <span className="text">
                <span className="title">
                  {t(`${prefix}.${key}.title`)}
                  {main && <PlusTag>✦ {t(`${prefix}.ai.badge`)}</PlusTag>}
                </span>
                <span className="description">{t(`${prefix}.${key}.description`)}</span>
              </span>
              <span className="chevron" aria-hidden="true">
                <ChevronRightIcon width={14} height={14} color="currentColor" />
              </span>
            </Option>
          </li>
        ))}
      </Options>
    </div>
  );
};

export default StartPage;
